import React from "react";
import { Alert, Table, Button, Pagination } from "react-bootstrap";
import useMediaQuery from "../../utils/useMediaQuery";

export const PesticideTable = ({ products, title, emptyMessage, t, handleViewProductDetails }) => {
  const isMobile = useMediaQuery("(max-width: 768px)"); // Mover para dentro do componente

  return (
    <div className="mb-5">
      <h5 className="mb-3">{title}</h5>
      {products.length === 0 ? (
        <Alert variant="info">{emptyMessage}</Alert>
      ) : (
        <div className="table-responsive">
          <Table striped hover responsive>
            <thead>
              <tr>
                <th>{t.name}</th>
                {!isMobile && <th>{t.activeIngredient}</th>}
                <th>{t.controlTarget}</th>
                <th>{t.details}</th>
              </tr>
            </thead>
            <tbody>
              {products.map((product, index) => (
                <tr key={product.id}>
                  <td>{product.name}</td>
                  {!isMobile && <td>{product.activeIngredient}</td>}
                  <td>{product.controlTarget}</td>
                  <td>
                    <Button
                      variant="outline-info"
                      size="sm"
                      onClick={() => handleViewProductDetails(product)}
                    >
                      {t.viewDetails}
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      )}
    </div>
  );
};

export const FertilizerTable = ({ products, title, emptyMessage, t, handleViewProductDetails }) => {
  const isMobile = useMediaQuery("(max-width: 768px)"); // Mover para dentro do componente

  return (
    <div className="mb-5">
      <h5 className="mb-3">{title}</h5>
      {products.length === 0 ? (
        <Alert variant="info">{emptyMessage}</Alert>
      ) : (
        <div className="table-responsive">
          <Table striped hover responsive>
            <thead>
              <tr>
                <th>{t.name}</th>
                {!isMobile && <th>{t.activeIngredient}</th>}
                <th>{t.benefit}</th>
                <th>{t.details}</th>
              </tr>
            </thead>
            <tbody>
              {products.map((product, index) => (
                <tr key={product.id}>
                  <td>{product.name}</td>
                  {!isMobile && <td>{product.activeIngredient}</td>}
                  <td>{product.benefit}</td>
                  <td>
                    <Button
                      variant="outline-info"
                      size="sm"
                      onClick={() => handleViewProductDetails(product)}
                    >
                      {t.viewDetails}
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      )}
    </div>
  );
};

export const ProductPagination = ({ totalProductPages, currentProductPage, setCurrentProductPage }) => (
  totalProductPages > 1 && (
    <Pagination className="justify-content-center mt-4">
      <Pagination.First
        onClick={() => setCurrentProductPage(1)}
        disabled={currentProductPage === 1}
      />
      <Pagination.Prev
        onClick={() =>
          setCurrentProductPage((prev) => Math.max(prev - 1, 1))
        }
        disabled={currentProductPage === 1}
      />
      {[...Array(totalProductPages).keys()].map((number) => (
        <Pagination.Item
          key={number + 1}
          active={number + 1 === currentProductPage}
          onClick={() => setCurrentProductPage(number + 1)}
        >
          {number + 1}
        </Pagination.Item>
      ))}
      <Pagination.Next
        onClick={() =>
          setCurrentProductPage((prev) => Math.min(prev + 1, totalProductPages))
        }
        disabled={currentProductPage === totalProductPages}
      />
      <Pagination.Last
        onClick={() => setCurrentProductPage(totalProductPages)}
        disabled={currentProductPage === totalProductPages}
      />
    </Pagination>
  )
);